import React, { useRef, useState ,useEffect} from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { CascadeSelect } from 'primereact/cascadeselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { getCookie } from "../../helpers/cookie"
import { Toast } from "primereact/toast"
import axios from "axios";
import { SET_API_STATUS_FALSE, SET_API_STATUS_TRUE } from "../../store/calendar/actionTypes"
import { useDispatch } from "react-redux";
const LinkCandidates = ({SelectedData}) => {
    const [id,setid] = useState(null)
    const [selectedStatusWorkType, setSelectedStatusWorkType] = useState(null)
    useEffect(() => {
        if (SelectedData) {
            setid(SelectedData[0]?.__raw?.id);
            setSelectedStatusWorkType(SelectedData[0]?.__raw?.project_status)
        }
    }, [SelectedData]);
    const token = getCookie('access_token');
    const toast = useRef(null);
    const fileUploadRef = useRef(null)
    const [selectedLinkJob, setSelectedLinkJob] = useState(null)
    const [documentTypes, setdocumentTypes] = useState([])
    const [statusWorkTypes, setStatusWorkTypes] = useState([]);
     const dispatch = useDispatch();
    const handleProtectedAction = (action) => {
        if (!id || (Array.isArray(id) && id.length === 0)) {
            toast.current?.show({
                severity: "error",
                summary: "Validation",
                detail: "Please select at least one Project",
            });
            return;
        }
        action();
    };
    const getProjectStatus = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_Company_Contact}/company/lookups/?name=project_status`, 
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          setStatusWorkTypes(response.data.results.results);
        } catch (err) {
          console.log("Error fetching project status:", err);
        }
      }
     const getDoctType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=contact_document_type`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status===200) {
                    const options = response.data.results.results.map((category) => ({
            name: category.value
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (char) => char.toUpperCase()),
            code: category.id,
            }));
            setdocumentTypes(options);
            }
        } catch (err) {
            console.log(err);

        }
    }
    useEffect(()=>
    {
        getDoctType()
        getProjectStatus()
    },[])
    const [selectedLinkCandidate, setSelectedLinkCandidate] = useState(null);
    const [visibleLinkCandidate, setVisibleLinkCandidate] = useState(false);
    const [candidateDetailsVisible, setCandidateDetailsVisible] = useState(false);

    // potential 
    const [visiblePotentialCandidate, setVisiblePotentialCandidate] = useState(false);

    // submitted
    const [visibleSubmittedCandidate, setVisibleSubmittedCandidate] = useState(false);
    const moreoptions = [
        {
            name: 'Project Status',
            onClick: () => handleProtectedAction(() => setChangeStatusAction(true)),
        },
        {
            name: "Attachments",
            onClick: () => handleProtectedAction(() => setIsAttachDocumentVisible(true)),
        },
        // {
        //   name: "Delete",
        //   onClick: () => handleProtectedAction(() => {
        //     // your delete logic here
        //   }),
        // },
    ];

    const [jobName, setJobName] = useState("Web Developer");
    const [currentDateTime, setCurrentDateTime] = useState(new Date());
    const [userId, setUserId] = useState("Harish");
    const [subject, setSubject] = useState("");
    const [notes, setNotes] = useState("");

    const [selectedCandidates, setSelectedCandidates] = useState([]);
    const [candidates] = useState([
        { id: 1, name: 'LavanKumar Kalvala', designation: 'Frontend Developer', company: 'Varun Digital Media' },
        { id: 2, name: 'Venkata Laxmi Valle', designation: 'Frontend Developer', company: 'Varun Digital Media' },
        { id: 3, name: 'Bhargavi Sunanda', designation: 'SEO', company: 'Varun Digital Media' },
        { id: 4, name: 'Nagendra Meriga', designation: 'Content Writer', company: 'Varun Digital Media' },
        { id: 5, name: 'Saikumar Kunda', designation: 'Backend', company: 'Pranathi Software Services' },
    ]);

    const [searchText, setSearchText] = useState('');
    const [selectedCandidateNames, setSelectedCandidateNames] = useState('');

    const handleIconClick = () => {
        setCandidateDetailsVisible(true);
    };

    const handleSave = () => {
        const selectedNames = selectedCandidates.map((candidate) => candidate.name).join(', ');
        setSelectedCandidateNames(selectedNames);
        setCandidateDetailsVisible(false);
    };

    const handleRefresh = () => {
        setSelectedCandidates([]);
        setSearchText('');
    };

    const filteredCandidates = candidates.filter(
        (candidate) =>
            candidate.name.toLowerCase().includes(searchText.toLowerCase()) ||
            candidate.designation.toLowerCase().includes(searchText.toLowerCase()) ||
            candidate.company.toLowerCase().includes(searchText.toLowerCase()) ||
            candidate.id.toString().includes(searchText)
    );

    // change status

    const [changeStatusAction, setChangeStatusAction] = useState(false)


    // more attachment starts
    const [isAttachDocumentVisible, setIsAttachDocumentVisible] = useState(false);

    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    // const documentTypes = [
    //     { name: "Scope Document", code: "SD" },
    //     { name: "Work Breakdown Structure (WBS)", code: "WBS" },
    //     { name: "Resource Allocation Document", code: "RAD" },
    //     { name: "Stakeholder List", code: "SL" },
    //     { name: "Approval and Sign-Off Forms", code: "ASF" },
    // ];

    const [uploadedFiles, setUploadedFiles] = useState([]);

    const onUpload = (event) => {
        // Store the uploaded files in state
        setUploadedFiles((prevFiles) => [...prevFiles, ...event.files]);
    };

    const [docSubject, setDocSubject] = useState("");
     const handleFileUploadChange = (e) => {
    const f = e.target.files && e.target.files[0]
    setUploadedFiles(f)
  } 
  const handleCloseDialog = () => {
    setIsAttachDocumentVisible(false);
    setSelectedDocumentType(null);
    setDocSubject("");
    setUploadedFiles(null);
    setStatusWorkTypes([]);
    setSelectedStatusWorkType(null); 
    setChangeStatusAction(false);
};

    const handleSubnit = async () => {
        try {
            const formData = new FormData()
            formData.append('title', selectedDocumentType?.code)
            formData.append('description', docSubject)
            // formData.append('file', uploadedFiles)
            if (uploadedFiles instanceof File) {
                formData.append('file', uploadedFiles);
            }
            else if (Array.isArray(uploadedFiles)) {
                uploadedFiles.forEach((file, idx) => {
                    formData.append('file', file); 
                });
            }
            const response = await axios.post(`${process.env.REACT_APP_Company_Contact}/company/projects/${id}/documents/`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 201) {
                toast.current && toast.current.show({ severity: 'success', summary: 'Added', detail: 'Document Added Successfully' })
                handleCloseDialog()
                dispatch({ type: SET_API_STATUS_TRUE })
                setTimeout(() => {
                    dispatch({ type: SET_API_STATUS_FALSE })
                }, 2000)
            }
        } catch (err) {
            console.log(err);

        }
    }
     const handleStatus = async () => {
        try {
            let payload = {
               project_status: selectedStatusWorkType,
            };
            const response = await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/projects/${id}/`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                toast.current && toast.current.show({ severity: 'success', summary: 'Updated', detail: 'Status Updated Successfully' })
                handleCloseDialog()
                dispatch({ type: SET_API_STATUS_TRUE })
                setTimeout(() => {
                    dispatch({ type: SET_API_STATUS_FALSE })
                }, 2000)
            }
        } catch (err) {
            console.log(err);

        }
    }
    return (
        <React.Fragment>
            <Toast ref={toast} />
            <CascadeSelect
                // value={selectedLinkCandidate}
                onChange={(e) => {
                    setSelectedLinkCandidate(e.value);
                    if (e.value && e.value.onClick) {
                        e.value.onClick();
                    }
                }}
                options={moreoptions}
                optionLabel="name"
                optionGroupLabel="name"
                optionGroupChildren={['candidates']}
                className="md:w-8rem"
                breakpoint="767px"
                placeholder="More"
            />
            <Dialog header="Link Web Developer as Received" visible={visibleLinkCandidate} onHide={() => setVisibleLinkCandidate(false)}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} className="link-candidates">
                <Row>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="job" className="block mb-0">
                                Jobs
                            </label>
                            <InputText
                                id="job"
                                value={jobName}
                                readOnly
                                className="w-full"
                                disabled
                            />
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="candidateDetail" className="block mb-0">Link Candidates</label>
                            <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                                <InputText
                                    id="candidateDetail"
                                    value={selectedCandidateNames}
                                    onChange={(e) => setSelectedCandidateNames(e.target.value)}
                                    placeholder="Select Candidates"
                                    className="w-full"
                                    style={{ paddingRight: '2rem' }} 
                                />
                                <i
                                    className="pi pi-chevron-down"
                                    onClick={handleIconClick}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer'
                                    }}
                                ></i>
                            </div>

                            <Dialog
                                header="Link Candidates"
                                visible={candidateDetailsVisible}
                                onHide={() => setCandidateDetailsVisible(false)}
                                style={{ width: '40vw' }}
                                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                className="cand-details"
                            >
                                {/* Search Bar */}
                                <Row>
                                    <Col lg={12}>
                                        <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                            <InputText
                                                placeholder="Search Candidates"
                                                value={searchText}
                                                onInput={(e) => setSearchText(e.target.value)}
                                                style={{ paddingRight: '2rem' }}
                                            />
                                            <i
                                                className="pi pi-search"
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '49%',
                                                    transform: 'translateY(-50%)',
                                                }}
                                            ></i>
                                        </div>
                                    </Col>
                                </Row>

                                {/* DataTable */}
                                <DataTable
                                    value={filteredCandidates}
                                    paginator
                                    rows={5}
                                    selection={selectedCandidates}
                                    onSelectionChange={(e) => setSelectedCandidates(e.value)}
                                    dataKey="id"
                                    rowsPerPageOptions={[5, 10, 25]}
                                    size="small"
                                >
                                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                                    <Column field="name" header="Candidate Name" />
                                    <Column field="designation" header="Designation" />
                                    <Column field="company" header="Company" />
                                </DataTable>

                                {/* Actions */}
                                <div className="d-flex  mt-3">
                                    <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>Ok</button>
                                    <button type="button" className="btn btn-primary btn-main" onClick={handleRefresh}>Refresh</button>
                                </div>
                            </Dialog>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="currentDateTime" className="block mb-0">
                                Date
                            </label>
                            <Calendar
                                id="currentDateTime"
                                value={currentDateTime}
                                onChange={(e) => setCurrentDateTime(e.value)}
                                showTime
                                showIcon
                                dateFormat="dd/mm/yy"
                                hourFormat="12"
                                readOnlyInput
                                className="w-full"
                            />
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="userId" className="block mb-0">
                                User ID
                            </label>
                            <InputText
                                id="userId"
                                value={userId}
                                readOnly
                                className="w-full"
                                placeholder="User ID"
                                disabled
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="subject" className="block mb-0">
                                Subject
                            </label>
                            <InputText
                                id="subject"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                className="w-full"
                                placeholder="Enter subject"
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="notes" className="block mb-0">
                                Notes
                            </label>
                            <InputTextarea
                                id="notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                rows={3}
                                cols={20}
                                className="w-full"
                                placeholder="Enter your notes here..."
                                autoResize
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn btn-primary me-2 btn-main" onClick={() => setVisibleLinkCandidate(false)}>Ok</button>
                            <button
                                color="primary"
                                className="btn btn-primary me-2 cancel-outlinebtn"
                                onClick={() => setVisibleLinkCandidate(false)}
                            >
                                <i className="pi pi-times me-1"></i>
                                Cancel
                            </button>
                        </div>
                    </Col>
                </Row>
            </Dialog>

            {/* potential starts */}

            <Dialog
                header="Link Web Developer as Potential"
                visible={visiblePotentialCandidate}
                onHide={() => setVisiblePotentialCandidate(false)}
                style={{ width: '50vw' }}
                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                className="link-candidates"
            >
                <Row>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="job" className="block mb-0">
                                Job
                            </label>
                            <InputText
                                id="job"
                                value={jobName}
                                readOnly
                                className="w-full"
                                disabled
                            />
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="candidateDetail" className="block mb-0">Link Candidates</label>
                            <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                                <InputText
                                    id="candidateDetail"
                                    value={selectedCandidateNames}
                                    onChange={(e) => setSelectedCandidateNames(e.target.value)}
                                    placeholder="Enter Candidate"
                                    className="w-full"
                                    style={{ paddingRight: '2rem' }} // Ensure space for the icon
                                />
                                <i
                                    className="pi pi-chevron-down"
                                    onClick={handleIconClick}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer'
                                    }}
                                ></i>
                            </div>

                            <Dialog
                                header="Link Candidates"
                                visible={candidateDetailsVisible}
                                onHide={() => setCandidateDetailsVisible(false)}
                                style={{ width: '40vw' }}
                                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                className="cand-details"
                            >
                                {/* Search Bar */}
                                <Row>
                                    <Col lg={12}>
                                        <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                            <InputText
                                                placeholder="Search Candidates"
                                                value={searchText}
                                                onInput={(e) => setSearchText(e.target.value)}
                                                style={{ paddingRight: '2rem' }}
                                            />
                                            <i
                                                className="pi pi-search"
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '49%',
                                                    transform: 'translateY(-50%)',
                                                }}
                                            ></i>
                                        </div>
                                    </Col>
                                </Row>

                                {/* DataTable */}
                                <DataTable
                                    value={filteredCandidates}
                                    paginator
                                    rows={5}
                                    selection={selectedCandidates}
                                    onSelectionChange={(e) => setSelectedCandidates(e.value)}
                                    dataKey="id"
                                    rowsPerPageOptions={[5, 10, 25]}
                                    size="small"
                                >
                                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                                    <Column field="name" header="Candidate Name" />
                                    <Column field="designation" header="Designation" />
                                    <Column field="company" header="Company" />
                                </DataTable>

                                {/* Actions */}
                                <div className="d-flex  mt-3">
                                    <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>Ok</button>
                                    <button type="button" className="btn btn-primary btn-main" onClick={handleRefresh}>Refresh</button>
                                </div>
                            </Dialog>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="currentDateTime" className="block mb-0">
                                Date
                            </label>
                            <Calendar
                                id="currentDateTime"
                                value={currentDateTime}
                                onChange={(e) => setCurrentDateTime(e.value)}
                                showTime
                                showIcon
                                dateFormat="dd/mm/yy"
                                hourFormat="12"
                                readOnlyInput
                                className="w-full"
                            />
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="userId" className="block mb-0">
                                User ID
                            </label>
                            <InputText
                                id="userId"
                                value={userId}
                                readOnly
                                className="w-full"
                                placeholder="User ID"
                                disabled
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="subject" className="block mb-0">
                                Subject
                            </label>
                            <InputText
                                id="subject"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                className="w-full"
                                placeholder="Enter subject"
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="notes" className="block mb-0">
                                Notes
                            </label>
                            <InputTextarea
                                id="notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                rows={3}
                                cols={20}
                                className="w-full"
                                placeholder="Enter your notes here..."
                                autoResize
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn btn-primary me-2 btn-main" onClick={() => setVisiblePotentialCandidate(false)}>Ok</button>
                            <button
                                color="primary"
                                className="btn btn-primary me-2 cancel-outlinebtn"
                                onClick={() => setVisiblePotentialCandidate(false)}

                            >
                                <i className="pi pi-times me-1"></i>
                                Cancel
                            </button>
                        </div>
                    </Col>
                </Row>
            </Dialog>

            {/* potential ends */}

            {/* submitted starts */}

            <Dialog
                header="Link Web Developer as Submitted"
                visible={visibleSubmittedCandidate}
                onHide={() => setVisibleSubmittedCandidate(false)}
                style={{ width: '50vw' }}
                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                className="link-candidates"
            >
                <Row>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="job" className="block mb-0">
                                Job
                            </label>
                            <InputText
                                id="job"
                                value={jobName}
                                readOnly
                                className="w-full"
                                disabled
                            />
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="candidateDetail" className="block mb-0">Link Candidates</label>
                            <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                                <InputText
                                    id="candidateDetail"
                                    value={selectedCandidateNames}
                                    onChange={(e) => setSelectedCandidateNames(e.target.value)}
                                    placeholder="Enter Candidate"
                                    className="w-full"
                                    style={{ paddingRight: '2rem' }} // Ensure space for the icon
                                />
                                <i
                                    className="pi pi-chevron-down"
                                    onClick={handleIconClick}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer'
                                    }}
                                ></i>
                            </div>

                            <Dialog
                                header="Link Candidates"
                                visible={candidateDetailsVisible}
                                onHide={() => setCandidateDetailsVisible(false)}
                                style={{ width: '40vw' }}
                                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                className="cand-details"
                            >
                                {/* Search Bar */}
                                <Row>
                                    <Col lg={12}>
                                        <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                            <InputText
                                                placeholder="Search Candidates"
                                                value={searchText}
                                                onInput={(e) => setSearchText(e.target.value)}
                                                style={{ paddingRight: '2rem' }}
                                            />
                                            <i
                                                className="pi pi-search"
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '49%',
                                                    transform: 'translateY(-50%)',
                                                }}
                                            ></i>
                                        </div>
                                    </Col>
                                </Row>

                                {/* DataTable */}
                                <DataTable
                                    value={filteredCandidates}
                                    paginator
                                    rows={5}
                                    selection={selectedCandidates}
                                    onSelectionChange={(e) => setSelectedCandidates(e.value)}
                                    dataKey="id"
                                    rowsPerPageOptions={[5, 10, 25]}
                                    size="small"
                                >
                                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                                    <Column field="name" header="Candidate Name" />
                                    <Column field="designation" header="Designation" />
                                    <Column field="company" header="Company" />
                                </DataTable>

                                {/* Actions */}
                                <div className="d-flex  mt-3">
                                    <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>Ok</button>
                                    <button type="button" className="btn btn-primary btn-main" onClick={handleRefresh}>Refresh</button>
                                </div>
                            </Dialog>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="currentDateTime" className="block mb-0">
                                Date
                            </label>
                            <Calendar
                                id="currentDateTime"
                                value={currentDateTime}
                                onChange={(e) => setCurrentDateTime(e.value)}
                                showTime
                                showIcon
                                dateFormat="dd/mm/yy"
                                hourFormat="12"
                                readOnlyInput
                                className="w-full"
                            />
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="userId" className="block mb-0">
                                User ID
                            </label>
                            <InputText
                                id="userId"
                                value={userId}
                                readOnly
                                className="w-full"
                                placeholder="User ID"
                                disabled
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="subject" className="block mb-0">
                                Subject
                            </label>
                            <InputText
                                id="subject"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                className="w-full"
                                placeholder="Enter subject"
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="notes" className="block mb-0">
                                Notes
                            </label>
                            <InputTextarea
                                id="notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                rows={3}
                                cols={20}
                                className="w-full"
                                placeholder="Enter your notes here..."
                                autoResize
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn btn-primary me-2 btn-main" onClick={() => setVisibleSubmittedCandidate(false)}>Ok</button>
                            <button
                                color="primary"
                                className="btn btn-primary me-2 cancel-outlinebtn"
                                onClick={() => setVisibleSubmittedCandidate(false)}

                            >
                                <i className="pi pi-times me-1"></i>
                                Cancel
                            </button>
                        </div>
                    </Col>
                </Row>
            </Dialog>

            {/* submitted ends */}

            {/* change status starts */}

            <Dialog
                header="Change Status"
                visible={changeStatusAction}
                onHide={() => setChangeStatusAction(false)}
                style={{ width: '30vw' }}
                className="changestatus-popup"
            >
                {/* Search Bar */}
                <Row className="mt-2 align-items-center">
                    <Col xl={2}>
                        <label className="block mb-2"                                  >
                            Status
                        </label>
                    </Col>
                    <Col xl={10}>
                        <div className="card flex justify-content-center mb-0 border-0">
                            <Dropdown
                                id="project"
                                value={selectedStatusWorkType}
                                onChange={(e) => setSelectedStatusWorkType(e.value)}
                                options={statusWorkTypes}
                                placeholder="Select Status"
                                className="w-full bgclr"
                                optionLabel="value"
                                optionValue="id"
                                filter
                            />
                        </div>
                    </Col>
                </Row>

                <div className="d-flex justify-content-end  mt-4">
                    <button type="button" class="btn btn-primary btn-main" onClick={handleStatus}>Submit</button>
                </div>
            </Dialog>

            {/* chnage status ends */}

            {/* attachements starts */}

            <Dialog
                header="Attachments"
                visible={isAttachDocumentVisible}
                onHide={handleCloseDialog}
                style={{ width: '45vw' }}
                breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            >
                <Row className="align-items-center">
                    <Col xl={6}>
                        <div className="card flex justify-content-center mb-0 border-0">
                            <label className="block mb-2">
                                Document Type
                            </label>
                            <Dropdown
                                value={selectedDocumentType}
                                onChange={(e) => setSelectedDocumentType(e.value)}
                                options={documentTypes}
                                optionLabel="name"
                                placeholder="Select a Document Type"
                                className="w-full bgclr"
                            />
                        </div>
                    </Col>

                    <Col lg={6}>
                        <div className="p-field mt-2">
                            <label htmlFor="docSubject" className="block">Document Subject</label>
                            <InputText
                                id="docSubject"
                                value={docSubject}
                                onChange={(e) => setDocSubject(e.target.value)}
                                placeholder="Enter Document Subject"
                                className="p-inputtext-sm w-full"
                            />
                        </div>
                    </Col>

                    <Col lg={12}>
                        <div className="card flex justify-content-center mb-0 border-0 mt-2">
                            <label className="block mb-2">
                                Attach Documents
                            </label>
                            <FileUpload
                                ref={fileUploadRef}
                                name="files[]"
                                accept="image/jpg,image/jpeg,image/png,application/pdf"
                                maxFileSize={1000000}
                                multiple
                                customUpload
                                auto
                                uploadHandler={(e) => {
                                    setUploadedFiles(e.files)
                                }}
                                onClear={() => {
                                    console.log("Files cleared")
                                    setUploadedFiles([])
                                }}
                            />
                        </div>
                    </Col>

                    <Col lg={12}>
                        <button
                            className="btn btn-primary btn-main mt-2"
                            onClick={handleSubnit}
                        >
                            Submit
                        </button>
                    </Col>
                </Row>
            </Dialog>

            {/* attachements ends */}


        </React.Fragment>
    );
};

export default LinkCandidates;
